<template>
    <div>
        <ZhDialog v-model="visible" width="400" center align-center show-close title="提示" @close="onClose">
            <div class="enter-change-content">
                <div v-if="!accountStore.isSubAccount" class="tip">您的企业认证已发生变更，请重新认证</div>
                <div v-else class="tip">当前企业认证信息已失效， 请等待重新认证生效后再登录。</div>
            </div>
            <template #footer>
                <div class="zh-dialog__footer">
                    <ElButton v-if="!accountStore.isSubAccount" type="primary" @click="goToAuth">重新认证</ElButton>
                    <ElButton v-else type="primary" @click="goLogin">确认</ElButton>
                </div>
            </template>
        </ZhDialog>
    </div>
</template>

<script setup lang="ts">
import { ZhDialog } from "zhihao-ui";
import { ElButton } from "element-plus";
import { useAccountStore } from "@/stores/account";
import { useRuntimeConfig } from "@/stores/runtimeConfig";
import * as loginService from "@/api/loginService";
import { useUserStore } from "@/stores/user";

const accountStore = useAccountStore();

const userStore = useUserStore();

const visible = defineModel<boolean>("visible", { default: true });

// 去认证
const goToAuth = () => {
    const publicInfo = useRuntimeConfig().public as { publicPath: string };
    visible.value = false;
    window.open(`${window.location.origin}${publicInfo.publicPath}me/authentication`, "_self");
};

// 退出登录
const goLogin = async () => {
    const publicInfo = useRuntimeConfig().public as { publicPath: string };
    await loginService.logout();
    userStore.clear();
    window.open(`${window.location.origin}${publicInfo.publicPath}login`, "_self");
};
const onClose = async () => {
    if (accountStore.isSubAccount) {
        await goLogin();
    }
};
</script>

<style scoped lang="scss"></style>
